import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** Contract update request body */
export interface ContractFormInterface {
  /** Contract number */
  number: string;
  /** Contract display name */
  name: string;
  /** Related company */
  company: CompanyFindInterface;
  /** Related counterparty */
  contragent: ContragentFindInterface;
  /** Contract beginning date */
  date?: Date;
  /** If `true` then related documents will be excluded from analytics */
  ignoreInAnalytics?: boolean;
}

/** Contract update request body - DTO schema */
export const ContractFormDto = SerdeDtoClass.create<ContractFormInterface>(DocumentDtoKeysEnum.CONTRACT_FORM_DTO, {
  number: {
    label: 'Номер',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  company: {
    label: 'Компания',
    checkers: [ClientCheckerKeysEnum.COMPANY_ASSERT_EXISTS_BY_DTO],
    serializer: yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>,
  },
  contragent: {
    label: 'Контрагент',
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
    serializer: yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>,
  },
  date: {
    label: 'Дата начала договора',
    optional: true,
    serializer: yup.date(),
  },
  ignoreInAnalytics: {
    optional: true,
    label: 'Не учитывать документы в аналитике',
    serializer: yup.boolean(),
  },
});
